import ModalShell from "../ModalShell";
import styles from "./style.module.scss";

export interface PlanCompareRow {
  label: string;
  previous: string | number;
  next: string | number;
  /** Bolds the row where the two plans actually differ. */
  changed?: boolean;
}

export interface PlanCampus {
  title?: string;
  students?: number | string;
  teachers?: number | string;
  city?: string;
  phone?: string;
  address?: string;
}

interface PlanCompareModalProps {
  open: boolean;
  rows: PlanCompareRow[];
  onClose: () => void;
  title?: string;
  subtitle?: string;
  previousLabel?: string;
  nextLabel?: string;
  /** Campuses the plan created, when it created any. */
  campuses?: PlanCampus[];
}

/** Side-by-side comparison of the plan being replaced and the one replacing it. */
function PlanCompareModal({
  open,
  rows,
  onClose,
  title = "Plan details",
  subtitle,
  previousLabel = "Previous plan",
  nextLabel = "New plan",
  campuses,
}: PlanCompareModalProps) {
  return (
    <ModalShell
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      width={640}
    >
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th} />
              <th className={styles.th}>{previousLabel}</th>
              <th className={styles.th}>{nextLabel}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.label}>
                <td
                  className={styles.td}
                  data-changed={row.changed ? "true" : undefined}
                >
                  {row.label}
                </td>
                <td
                  className={styles.td}
                  data-changed={row.changed ? "true" : undefined}
                >
                  {row.previous}
                </td>
                <td
                  className={`${styles.td} ${styles.next}`}
                  data-changed={row.changed ? "true" : undefined}
                >
                  {row.next}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {campuses?.map((campus, index) => (
        <div key={index} className={styles.campus}>
          <div className={styles.campusHead}>
            <div className={styles.campusTitle}>Campus details</div>
            <span className={styles.campusBadge}>Campus created</span>
          </div>
          <dl className={styles.campusFacts}>
            <div className={styles.campusRow}>
              <dt>Title</dt>
              <dd>{campus.title || "—"}</dd>
            </div>
            <div className={styles.campusRow}>
              <dt>Students</dt>
              <dd>{campus.students ?? "—"}</dd>
            </div>
            <div className={styles.campusRow}>
              <dt>Teachers</dt>
              <dd>{campus.teachers ?? "—"}</dd>
            </div>
            {campus.city && (
              <div className={styles.campusRow}>
                <dt>City</dt>
                <dd>{campus.city}</dd>
              </div>
            )}
            {campus.phone && (
              <div className={styles.campusRow}>
                <dt>Phone</dt>
                <dd>{campus.phone}</dd>
              </div>
            )}
            {campus.address && (
              <div className={styles.campusRow}>
                <dt>Address</dt>
                <dd>{campus.address}</dd>
              </div>
            )}
          </dl>
        </div>
      ))}
    </ModalShell>
  );
}

export default PlanCompareModal;
